export enum ApiError {
  NotFound = 'No resource found',
  DefaultMessage = 'Something went wrong',
}
